<!--components/app/DialogAlert-->
<template>
	<v-dialog
		v-model="dialog"
		:width="450"
		persistent
	>

		<v-card>
			<v-card-title
				class="headline"
				v-bind:class="calculateClass()">

				{{ getTitle() }}
			</v-card-title>

			<v-card-text class="mt-5">
				{{ message }}
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn
					@click="handleOK"
					:color="calculateClass()">OK</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			message: {
				type: String,
				default: undefined
			},

			show: {
				type: Boolean,
				default: false
			},

			messageType: {
				type: String,
				default: 'info'
			}
		},

		data() {
			return {
				dialog: this.show
			}
		},

		watch: {
			show: function () {
				this.dialog = this.show
			}
		},

		methods: {
			calculateClass() {
				switch (this.messageType) {
					case 'error':
						return 'error'
					case 'success':
						return 'success'
					default:
						return 'info'
				}
			},

			getTitle() {
				switch (this.messageType) {
					case 'error':
						return 'Error'
					case 'success':
						return 'Success'
					default:
						return 'Info'
				}
			},

			handleOK() {
				this.$emit('dialog-alert-closed')
				this.dialog = false
			}
		}
	}
</script>